import { attr, belongsTo, hasMany } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

const Cart = ApplicationRecord.extend({
  static: {
    jsonapiType: 'carts',
  },
  attrs: {
    email: attr(),
    apiTax: attr({ persist: false }),
    subtotal: attr({ persist: false }),
    apiTotal: attr({ persist: false }),
    shipping: attr({ persist: false }),
    plainSubtotal: attr({ persist: false }),
    subtotalWithoutCoupon: attr({ persist: false }),
    shoobId: attr(),
    zipCode: attr(),
    cartType: attr(),
    couponId: attr(),
    schoolId: attr(),
    messageId: attr(),
    couponValue: attr({ persist: false }),
    from: attr(),
    createdLocation: attr(),
    entryMethod: attr(),
    price: attr({ persist: false }),
    cartId: attr({ persist: false }),
    processed: attr({ persist: false }),
    purchased: attr({ persist: false }),
    idSupplied: attr({ persist: false }),
    qualifiesForFreeAnnouncements: attr({ persist: false }),
    // The free-magnets tier (issue #5218): read-only, from Api::CartResource.
    qualifiesForFreeMagnets: attr({ persist: false }),
    hasFreeMagnets: attr({ persist: false }),
    // The free-item offer (#5747), PER ORDER PACKAGE: [{ order_package_id,
    // addon_id, addon_sheet_id }] for every line the offer covers -- addon_id
    // set once the parent has picked. Snake-case keys inside (an array value).
    freeItemPackages: attr({ persist: false }),
    // Does the attached coupon waive the retouching charge? Read-only, from
    // Api::CartResource -- the retouching upsell gates its "Free" on this so the
    // screen can never promise a $0 the charge will not honour.
    waivesRetouching: attr({ persist: false }),
    // Is shipping waived on THIS cart (Cart#waives_shipping?, the predicate the
    // charge uses) -- differs from the offer's own flag for a free-shipping-over
    // coupon under its minimum -- and how much more would waive it. Undeclared
    // attributes are dropped by spraypaint; both are read by couponSummary.js.
    waivesShipping: attr({ persist: false }),
    amountToFreeShipping: attr({ persist: false }),
    school: belongsTo(),
    coupon: belongsTo(),
    orderPackages: hasMany(),
    orders: hasMany(),
  },
});

export default Cart;
